const validateForm = (fields) => {
  let isValid = false;
  isValid = Object.values(fields).every(field => field === true);
  return isValid;
}

export default validateForm;